export default __webpack_public_path__ + "static/media/newEnglandPatriots@2x.e3ccfa0a.jpg";